export default __webpack_public_path__ + "locales/vi/ConvertDialog.json?hash=2c28982f2f9d2ee4941d2a396eff157e";